'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NitroCard = require('./NitroCard');

var _NitroCard2 = _interopRequireDefault(_NitroCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NitroCard2.default;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-card/index.js
// module id = 2892
// module chunks = 4